<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <template #activator="{on}">
      <v-btn v-on="on" text left>
        <v-icon small left>fas fa-pen</v-icon>
        {{ item.InvName }}-{{ item.qty }}</v-btn
      >
    </template>
    <v-card>
      <v-card-title primary-title>
        {{ `${item.InvName} (${ItemQTY && ItemQTY.toLocaleString()})` }}
        <v-spacer></v-spacer>
        <v-btn @click="close" icon color="primary">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row class="justify-center mt-3">
          <v-col cols="10">
            <v-form ref="QtyValidate">
              <BaseNumInput
                :rules="[valideQty]"
                outlined
                v-model="item.qty"
                label="QUANTITY"
              ></BaseNumInput>
              <BaseNumInput
                outlined
                v-model="item.price"
                label="PRICE"
              ></BaseNumInput>
            </v-form>
          </v-col>
        </v-row>

        <!-- <p>{{ item }}</p> -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    item: { type: Object, required: true },
    RemainQty: { type: Object, required: true },
    SellType: { type: String, default: "wholesale" },
  },
  data() {
    return {
      dialog: false,
      totalQty: 0,
    };
  },

  computed: {
    ItemQTY() {
      if (this.SellType == "wholesale") return this.RemainQty.qty;
      return this.RemainQty.qty * this.RemainQty.UnitQty;
    },
  },

  methods: {
    valideQty(val) {
      // console.log(val);
      //   Number(v.replace(/,/g, ""))
      if (!isNaN(val))
        this.item.qty = parseInt(val.toString().replace(/,/g, "")) || 0;
      // console.log(this.item.qty);
      if (val == 0) return `0 is not allowed`;
      if (this.ItemQTY >= this.item.qty) return true;

      return `you don't have ${val} Qty of ${this.item.InvName}`;
    },
    close() {
      //   console.log(this.$refs.QtyValidate.validate());
      if (this.$refs.QtyValidate.validate()) this.dialog = false;
    },
    OpenDialog() {
      // console.log(this.item);
      this.dialog = true;
    },
  },
};
</script>
